import { POST, PUT, GET, DELETE, PATCH } from '../http';

export const Reservations = {
  Search: (spec) => {
    return POST('next/Reservation/Search', spec);
  },
  GetReservation: (id, spec) => {
    return GET('next/Reservation/GetReservation/' + id, spec);
  },
  CreateReservation: spec => {
    return POST('next/Reservation/CreateReservation', spec)
  },
  UpdateReservation: spec => {
    return PUT('next/Reservation/UpdateReservation', spec)
  },
  PatchReservation: spec => {
    return PATCH('next/Reservation/PatchReservation', spec, Object.getOwnPropertyNames(spec))
  },
  SearchArrivalAndGuestInHouse: (spec) => {
    return POST('next/Reservation/SearchArrivalAndGuestInHouse', spec);
  },
  GetReservationGroup: (spec) => {
    return POST('next/Reservation/GetGroupReservation', spec);
  }
};
export const Invoice = {
  GetTaxAuthorityApproval: (spec) => {
    return POST('next/Invoice/GetTaxAuthorityApproval', spec)
  },
  RemoveTaxAuthorityPendingTag: (spec) => {
    return POST('next/Invoice/RemoveTaxAuthorityPendingTag', spec)
  },
  GetInvoice: (spec) => {
    return GET('next/Invoice/GetInvoice', spec)
  },
  ProcessRefusedInvoiceTreatment: (spec) => {
    return POST('next/Invoice/TreatRefusedInvoice', spec)
  },
  GetTaxAuthorityInvoiceErrors: (spec) => {
    return GET('next/Invoice/GetTaxAuthorityInvoiceErrors', spec)
  },
    PostInvoice:(spec) => {
    return POST('next/Invoice/PostInvoice',spec)
  },
  PostTaxAuthorityError: (spec) => {
    return POST('next/Invoice/PostTaxAuthorityError', spec)
  }
}
export const Customers = {
  GetCustomers: (spec) => {
    return GET('next/Customer/GetCustomers', spec);
  },
}
export const Reports = {
  GetReports: (spec) => {
    return GET('next/Reports/GetReports', spec);
  },
  Housekeeping: (spec) => {
    return GET('next/Reports/Housekeeping', spec);
  },
  InvoicesReceiptsReport: (spec) => {
    return POST('next/Reports/InvoicesReceiptsReport', spec);
  },
  CustomerCommission: (spec) => {
    return POST("next/Reports/CustomerCommissionReport", spec);
  },
  ApartmentOwnersReport: (spec) => {
    return POST('next/Reports/ApartmentOwnersReport', spec);
  },
  GroupReservationsByCheckInDateReport: (spec) => {
    return POST('next/Reports/GroupReservationsByCheckInDateReport', spec);
  }
};

export const Hotels = {
  GetHotels: (spec) => {
    return GET('next/Hotel/GetHotels', spec);
  },
};

export const Rooms = {
  GetRooms: (spec) => {
    return GET('next/Room/GetRooms', spec);
  },
};
export const RoomTypes = {
  GetRoomTypes: (spec) => {
    return GET('next/RoomType/GetRoomTypes', spec);
  },
};

export const Addons = {
  GetHotelChainAddons: (spec) => {
    return GET('next/Addon/GetHotelChainAddons', spec);
  }
}

export const RoomExpenses = {
  GetRoomExpenses: (spec) => {
    return GET('next/RoomExpenses/GetRoomExpenses', spec);
  },
  AddRoomExpenses: (data) => {
    return POST('next/RoomExpenses/PostRoomExpenses', data);
  }
  ,
  UpdateRoomExpenses: (data) => {
    return PUT('next/RoomExpenses/UpdateRoomExpenses', data);
  },
  DeleteRoomExpenses: (data) => {
    return DELETE('next/RoomExpenses/DeleteRoomExpenses', data);
  }
};
export const RoomExpenseType = {
  GetRoomExpenseType: (spec) => {
    return GET('next/RoomExpenseType/GetRoomExpenseType', spec);

  },
};
export const Clubs = {
  GetClubs: (spec) => {
    return GET('next/Club/GetClubs', spec)
  }
}

export const Guests = {
  Search: (spec) => {
    return GET('next/Guest/Search', spec);
  },
  GetGuests: (spec) => {
    return GET('next/Guest/GetGuests', spec);
  },
  GetGuest: (id, spec) => {
    return GET('next/Guest/GetGuest/' + id, spec);
  },
  GetApartmentOwners: (spec) => {
    return GET('next/Guest/GetAppartmentOwners', spec);
  },
  CheckClubMember:(spec) => {
    return GET('next/Guest/CheckClubMember',spec)
  }
};

export const Rates = {
  GetRates: (spec) => {
    return GET('next/Rate/GetRates', spec);
  },
};
export const Live = {
  GetLiveData: spec => {
    return GET('next/Live/GetLiveData', spec);
  }
}
export const Calendar = {
  GetHotelDateParameters: (spec) => {
    return GET('next/Calendar/GetHotelDateParameters', spec);
  },
  GetReservations: (spec) => {
    return GET('next/Calendar/GetReservations', spec);
  },
  GetAvailabilityData: (spec) => {
    return GET('next/Calendar/GetAvailabilityData', spec);
  },
  GetYieldData: (spec) => {
    return GET('next/Calendar/GetYieldData', spec);
  },
  GetCustomerIcon: (id) => {
    return GET('next/Calendar/GetCustomerIcon/' + id);
  }
};

export const Location = {
  GetLocation: (id) => {
    return GET('next/Location/GetLocation/' + id);
  }
}

export const RoomPlannedMaintenance = {
  GetRoomPlannedMaintenances: (spec) => {
    return GET('next/RoomPlannedMaintenance/GetRoomPlannedMaintenances', spec);
  },
};

export const ReservationPolicy = {
  GetReservationPolicies: (spec) => {
    return GET('next/ReservationPolicy/GetReservationPolicies', spec);
  },
  AddReservationPolicies: (spec) => {
    return POST('next/ReservationPolicy/AddReservationPolicies', spec);
  },
  GetCancellationPolicies: (spec) => {
    return GET('next/ReservationPolicy/GetCancellationPolicies', spec);
  },
  AddAndUpdateCancellationAndDepositPolicies: (spec) => {
    return POST(
      'next/ReservationPolicy/AddAndUpdateCancellationAndDepositPolicies',
      spec
    );
  },
  DeleteCancellationPolicy: (id) => {
    return DELETE('next/ReservationPolicy/DeleteCancellationPolicy', id);
  },
  DeleteDepositPolicy: (id) => {
    return DELETE('next/ReservationPolicy/DeleteDepositPolicy', id);
  },
  AddReservationPolicyExceptions: (spec) => {
    return POST(
      'next/ReservationPolicyException/AddReservationPolicyExceptions',
      spec
    );
  },
};

export const Settings = {
  GetEmailSettings: (spec) => {
    return GET('next/Settings/GetEmailSettings', spec)
  },
  PostEmailSettings: (spec) => {
    return POST('next/Settings/PostEmailSettings', spec)
  }
}

export const Tags = {
  GetTags: (spec) => {
    return GET('next/Tags/GetTags', spec);
  },
  AddTag: (spec) => {
    return POST('next/Tags/AddTag', spec);
  },
};

export const TagEntities = {
  GetGroupedTagEntities: (spec) => {
    return GET('next/TagEntities/GetGroupedTagEntities', spec);
  },
  GetFlatTagEntities: (spec) => {
    return GET(
      'next/TagEntities/GetFlatTagEntities',
      spec
    );
  },
  DeleteTagEntities: (ids) => {
    return DELETE(
      'next/TagEntities/DeleteTagEntities',
      ids
    );
  },
  CreateOrUpdateGroupedTagEntities: (spec) => {
    return POST(
      'next/TagEntities/CreateOrUpdateGroupedTagEntities',
      spec
    );
  },
  CreateTagEntities: (spec) => {
    return POST(
      'next/TagEntities/CreateTagEntities',
      spec
    );
  },
};


export const Nationalities = {
  GetNationalities: (spec) => {
    return GET('next/Nationalities/GetNationalities', spec)
  },
}

export const Products = {
  GetProducts: (spec) => {
    return GET('next/Product/GetProducts', spec);
  }
}

export const Print = {
  PrintReceipt: (id) => {
    return GET('next/Print/PrintReceipt/' + id)
  },
  PrintInvoice: (id, title) => {
    return GET('next/Print/PrintInvoice/' + id, { title })
  },
}

export const RMS = {
  GetRMSRules: spec => {
    return GET('next/RMS/GetRMSRules', spec)
  },
  PostRmsRules: (spec, data) => {
    return POST('next/RMS/PostRmsRules', data, null, spec)
  }
}
export const Folio = {
  GetPendingFoliosReport: (spec) => {
    return GET('next/Folio/GetPendingFoliosReport', spec)
  },
  GetTransactionRefundsDetails: (spec) => {
    return GET('next/Folio/GetTransactionRefundsDetails', spec)
  }
}
export const AccountingSystem = {
  GetAccountingSystemTypes: (spec) => {
    return GET('next/AccountingSystem/GetAccountingSystemTypes', spec)
  },
  GetOpenFormatLog: (spec) => {
    return GET('next/AccountingSystem/GetOpenFormatLog', spec)
  },
  GetHotelAccountingSystemTypes: (spec) => {
    return GET('next/AccountingSystem/GetHotelAccountingSystemTypes', spec)
  },
  GetTransactionCodeAccountingNumberMapping: (spec) => {
    return GET('next/AccountingSystem/GetTransactionCodeAccountingNumberMapping', spec)
  },
  PostTransactionCodeAccountingNumberMapping: (spec) => {
    return POST('next/AccountingSystem/PostTransactionCodeAccountingNumberMapping', spec)
  },
  PostPCNReport: (spec) => {
    return POST('next/AccountingSystem/PostPCNReport', spec)
  }
}
export const TransactionCode = {
  GetTransactionCode: (spec) => {
    return GET('next/TransactionCode/GetTransactionCode', spec)
  }
}
export const Menus = {
  GetUserMenus: () => {
    return GET('next/Menu/GetUserMenus')
  }
}
export const Document = {
  GetDocumentType: (spec) => {
    return GET('next/DocumentSeries/GetDocumentType', spec)
  },
  GetDocumentSubType: (spec) => {
    return GET('next/DocumentSeries/GetDocumentSubType', spec)
  },
  GetDocumentSeries: (spec) => {
    return GET('next/DocumentSeries/GetDocumentSeries', spec)
  },
  PostDocumentSeries: (data) => {
    return POST('next/DocumentSeries/PostDocumentSeries', data)
  }
}

export const ETL = {
  GetAnalyticsURL: () => {
    return GET('next/ETL/GetAnalyticsURL')
  },
  Authenticate: (domain) => {
    return POST('next/ETL/Authenticate', domain)
  },
  GetAnalyticsUsers: spec => {
    return GET('next/ETL/GetAnalyticsUsers', spec)
  },
  SaveOrUpdateAnalyticsUsers: spec => {
    return POST('next/ETL/SaveOrUpdateAnalyticsUsers', spec)
  },
  GetHotels: spec => {
    return GET('next/ETL/GetHotels', spec)
  },
}

export const CurrencyExchange = {
  GetHotelCurrencyExchangeRates: spec => {
    return GET('next/CurrencyExchange/GetHotelCurrencyExchangeRates', spec)
  },
  UpdateHotelCurrencyExchangeRates: spec => {
    return POST('next/CurrencyExchange/UpdateHotelCurrencyExchangeRates', spec)
  }
}

export const Templates = {
  GetTemplates: (spec) => {
    return GET('next/Templates/GetTemplates', spec);
  },
};

export const ReceptionAnywhere = {
  GetCombinedRegistrationPdf: (spec) => {
    return POST('next/ReceptionAnywhere/GetCombinedRegistrationPdf', spec);
  },
};

export const TaxIdentity = {
  GetTaxIdentities: (spec) => {
    return GET('next/TaxIdentity/GetTaxIdentities', spec);
  },
  GetTaxIdentity: (spec) => {
    return GET('next/TaxIdentity/GetTaxIdentity', spec);
  },
  GetCreateOrEditTaxIdentityHotelOptions: (spec) => {
    return GET('next/TaxIdentity/GetCreateOrEditTaxIdentityHotelOptions', spec);
  },
  GetTaxAuthorityRegisterUrl: (spec) => {
    return GET('next/TaxIdentity/GetTaxAuthorityRegisterUrl', spec);
  },
  TaxAuthorityHealthCheck: (spec) => {
    return POST('next/TaxIdentity/TaxAuthorityHealthCheck', spec);
  },
  CreateOrUpdateTaxIdentity: (spec) => {
    return POST('next/TaxIdentity/CreateOrUpdateTaxIdentity', spec);
  }
};

export const Users = {
  GetUsers: (spec) => {
    return GET('next/User/GetUsers', spec);
  }
};

export const Availability = {
  GetAvailability: (spec) => {
    return GET('next/Availability/GetAvailability', spec);
  },
  UpdateMaxOccupancy: (spec) => {
    return PUT('next/Availability/UpdateMaxOccupancy', spec);
  }
}